import React from "react";

const DetailsWindow = ({ title, children }) => {
  const childrenArray = React.Children.toArray(children);

  return (
    <div className="details-window">
      <span className="header-window">
        <h2>{title}</h2>
        {childrenArray.length > 1 ? childrenArray[0] : null}
      </span>
      {childrenArray.length > 1 ? childrenArray[1] : childrenArray[0]}
    </div>
  );
};

export default DetailsWindow;
